import script from "./FileUploadComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&setup=true&lang=js"

import "./FileUploadComponent.vue?vue&type=style&index=0&id=5d042c42&lang=css"

const __exports__ = script;

export default __exports__